<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Brand Area  -->
    <div class="rwt-brand-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="产品定制即将上线，敬请期待……"
                data-aos="fade-up"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Brand Area  -->



  </Layout>
</template>
<script>
import Layout from "../../components/common/Layout";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
export default {
  name: 'ProductCustomization',
  components: {Layout,SectionTitle},
  data() {
    return {

    }
  }
}
</script>

<style scoped>

</style>